/**
 * 营运管理模块翻译 - 中文
 * 包含：开业筹备管理、销售数据管理、现场管理
 */
export default {
  operation: {
    // 开业筹备管理
    renovation: {
      title: '开业筹备管理',
      // 统计卡片
      statPendingEntry: '待进场',
      statPendingReview: '待审图',
      statReviewRejected: '审图驳回',
      statReviewApproved: '审图通过',
      statRenovating: '装修中',
      statPendingOpening: '待开业',
      statOpened: '已开业',
      statEntryAndReview: '待进场 & 审图',
      // 搜索表单
      keyword: '关键字',
      keywordPlaceholder: '商户名/品牌名/铺位名/合同号',
      renovationStatus: '筹备状态',
      newApplication: '新建申请',
      hideSearch: '隐藏搜索',
      showSearch: '显示搜索',
      // 表格列
      shopName: '资产名称',
      merchantName: '商户名称',
      brandName: '品牌名称',
      contractNo: '合同编号',
      applyDate: '申请日期',
      plannedConstructionPeriod: '计划施工期',
      renovationManagerCol: '负责人',
      merchantContactTag: '商户',
      currentStatus: '当前状态',
      // 状态选项
      statusPendingEntry: '待进场',
      statusPendingReview: '待审图',
      statusReviewRejected: '审图驳回',
      statusReviewApproved: '审图通过',
      statusRenovating: '装修中',
      statusPendingOpening: '待开业',
      statusOpened: '已开业',
      // 操作按钮
      submitBlueprint: '提交审图',
      resubmitBlueprint: '重新提交',
      reviewBlueprint: '审图审批',
      approveEntry: '核准进场',
      completeAccept: '完工验收',
      confirmOpening: '确认开业',
      // 对话框标题
      addTitle: '新建开业筹备',
      editTitle: '编辑开业筹备',
      detailTitle: '筹备详情',
      submitBlueprintTitle: '提交装修图纸',
      resubmitBlueprintTitle: '重新提交图纸',
      reviewBlueprintTitle: '审图审批',
      entryTitle: '核准进场',
      acceptTitle: '完工验收',
      openingTitle: '确认开业',
      // 表单字段
      shop: '铺位',
      shopPlaceholder: '请选择铺位',
      relatedContract: '关联合同',
      contractPlaceholder: '请选择合同',
      merchant: '商户',
      merchantAutoFill: '选铺位后自动带出',
      brand: '品牌',
      plannedDateRange: '计划施工期',
      plannedStartPlaceholder: '开始日期',
      plannedEndPlaceholder: '结束日期',
      dateTo: '至',
      renovationDescription: '装修说明',
      renovationDescriptionPlaceholder: '请输入装修说明',
      // 进场表单
      renovationManager: '装修负责人',
      renovationManagerPlaceholder: '请输入装修负责人姓名',
      renovationManagerPhone: '负责人电话',
      renovationManagerPhonePlaceholder: '请输入装修负责人电话',
      entryPlannedDateRange: '计划装修期',
      // 验收表单
      acceptResult: '验收结果',
      acceptResultPassed: '通过',
      acceptResultFailed: '不通过',
      acceptRemarkLabel: '验收备注',
      acceptRemarkPlaceholder: '请输入验收备注',
      acceptResultRequired: '请选择验收结果',
      rejectReason: '驳回原因',
      rejectReasonPlaceholder: '请输入驳回原因',
      rejectReasonRequired: '验收不通过时必须填写驳回原因',
      renovationCompany: '装修公司',
      renovationCompanyPlaceholder: '请输入装修公司名称',
      // 开业确认表单
      openingDate: '实际开业日期',
      openingDatePlaceholder: '请选择实际开业日期',
      openingDateRequired: '请选择实际开业日期',
      // 新建申请增强字段
      renovationType: '装修类型',
      renovationTypePlaceholder: '请选择装修类型',
      renovationTypeRequired: '请选择装修类型',
      typeStandard: '标准装修',
      typeSimple: '简装翻新',
      typeMajor: '重大改造',
      renovationBudget: '装修预算（万元）',
      renovationBudgetPlaceholder: '请输入装修预算',
      merchantContactLabel: '商户联系人',
      merchantContactPlaceholder: '请输入商户联系人姓名',
      merchantContactRequired: '请输入商户联系人',
      merchantContactPhone: '联系电话',
      merchantContactPhonePlaceholder: '请输入商户联系电话',
      merchantContactPhoneRequired: '请输入商户联系电话',
      // 进场增强字段
      constructionPermit: '施工许可证号',
      constructionPermitPlaceholder: '请输入施工许可证号',
      entryNoticeConfirmed: '进场须知',
      entryNoticeLabel: '已告知商户装修管理规范及安全须知',
      entryNoticeRequired: '请确认已告知商户进场须知',
      entryRemark: '进场备注',
      entryRemarkPlaceholder: '请输入进场特殊说明',
      // 费用管理
      feeTitle: '装修费用',
      feeItem: '费用项目',
      feeItemPlaceholder: '选择或输入费用名称',
      feeAmount: '应收金额（元）',
      feeAmountPlaceholder: '请输入金额',
      feeRefundable: '可退',
      feeRemark: '备注',
      feeAdd: '添加费用',
      feeSaveSuccess: '费用保存成功',
      feeAmountTotal: '应收合计',
      feePaymentStatus: '收款状态',
      feePaidAmount: '已收金额',
      // 施工进度
      progressTitle: '施工进度',
      progressUpdate: '更新进度',
      progressUpdateTitle: '更新施工进度',
      progressStage: '施工进度',
      progressStagePlaceholder: '请选择当前进度阶段',
      progressStageRequired: '请选择施工进度',
      stagePreparation: '进场准备',
      stageConstruction: '主体施工',
      stageFinishing: '装饰收尾',
      stageSelfCheck: '自检整改',
      progressDescription: '进度说明',
      progressDescriptionPlaceholder: '请输入本次进度说明',
      progressSuccess: '进度记录已添加',
      // 整改通知
      rectificationTitle: '发送整改通知',
      rectificationSend: '发送整改通知',
      rectificationIssue: '整改问题',
      rectificationIssuePlaceholder: '请描述需要整改的问题',
      rectificationIssueRequired: '请输入整改问题',
      rectificationDeadline: '整改期限',
      rectificationDeadlinePlaceholder: '请选择整改截止日期',
      rectificationDeadlineRequired: '请选择整改期限',
      rectificationSuccess: '整改通知已发送',
      // 验收增强
      acceptanceChecklist: '验收检查项',
      checkAppearance: '店面外观与招牌',
      checkAppearanceDesc: '门头、招牌是否符合商场统一规范',
      checkUtility: '水电气接入',
      checkUtilityDesc: '水电气管线接入是否规范、计量表安装',
      checkFireSafety: '消防设施',
      checkFireSafetyDesc: '烟感、喷淋、灭火器、疏散标识是否合规',
      checkSafetyEnv: '安全与环保',
      checkSafetyEnvDesc: '安全出口畅通、建材环保合规、无安全隐患',
      checkCleaning: '卫生清洁',
      checkCleaningDesc: '施工垃圾清理完毕、店内卫生达标',
      checkAllRequired: '验收通过需全部检查项勾选通过',
      // 确认开业增强
      licenseChecklist: '证照核验',
      licenseBusiness: '营业执照',
      licenseBusinessDesc: '已取得或已备案',
      licenseFire: '消防验收合格',
      licenseFireDesc: '消防部门验收通过或备案',
      licenseHealth: '卫生许可',
      licenseHealthDesc: '食品/餐饮类业态必须',
      licenseBusinessRequired: '至少需确认营业执照',
      openingRemarkLabel: '开业备注',
      openingRemarkPlaceholder: '请输入开业特殊说明',
      // 铺位-合同级联提示
      noActiveContract: '该铺位暂无生效合同，无法新建筹备申请',
      contractAutoFill: '选择铺位后自动匹配',
      loadingContract: '正在查询合同...',
      // 表单校验
      shopRequired: '请选择铺位',
      contractRequired: '请选择关联合同',
      // 详情页
      processProgress: '流程进度',
      basicInfo: '基本信息',
      renovationInfo: '装修信息',
      plannedStartDate: '计划开始日期',
      plannedEndDate: '计划结束日期',
      actualStartDate: '实际开工日期',
      actualEndDate: '实际竣工日期',
      acceptRemark: '验收备注',
      // 审图相关字段
      blueprintAttachments: '图纸附件',
      blueprintAttachmentsPlaceholder: '请上传装修图纸（PDF/DWG/JPG/PNG）',
      blueprintAttachmentsRequired: '请上传图纸附件',
      blueprintAttachmentsTip: '支持 PDF、DWG、JPG、PNG 格式，单文件不超过 50MB',
      blueprintReviewResult: '审核结果',
      blueprintApproved: '通过',
      blueprintRejected: '不通过',
      blueprintRejectReason: '驳回原因',
      blueprintRejectReasonPlaceholder: '请输入驳回原因',
      blueprintRejectReasonRequired: '审图不通过时必须填写驳回原因',
      blueprintReviewRemark: '审核备注',
      blueprintReviewRemarkPlaceholder: '请输入审核备注（选填）',
      blueprintSubmitSuccess: '图纸提交成功',
      blueprintApproveSuccess: '审图通过',
      blueprintRejectSuccess: '审图已驳回',
      blueprintResultRequired: '请选择审核结果',
      blueprintInfo: '审图信息',
      blueprintSubmitDate: '提交日期',
      blueprintSubmitBy: '提交人',
      blueprintSubmissionCount: '提交次数',
      blueprintReviewDate: '审核日期',
      blueprintReviewBy: '审核人',
      blueprintViewFiles: '查看图纸',
      blueprintDownload: '下载',
      blueprintNoFiles: '暂无图纸',
      blueprintTimesUnit: '次',
      // 时间线节点
      nodePendingEntry: '待进场',
      nodePendingReview: '待审图',
      nodeReviewApproved: '审图通过',
      nodeRenovating: '装修中',
      nodePendingOpening: '待开业',
      nodeOpened: '已开业',
      // 确认消息
      deleteConfirm: '是否确认删除该筹备记录？',
      deleteWarning: '警告',
      entryConfirmMsg: '确认核准该商户进场装修？',
      entryConfirmTitle: '核准进场',
      openingConfirmMsg: '确认该商户已正式开业？此操作将回写合同开业日期并更新资产状态。',
      openingConfirmTitle: '确认开业',
      // 成功消息
      updateSuccess: '修改成功',
      submitSuccess: '申请提交成功',
      entrySuccess: '已核准进场',
      acceptSuccess: '验收提交成功',
      openingSuccess: '已确认开业',
    },
    // 销售数据管理
    sales: {
      title: '销售数据管理',
      // 统计卡片
      statPending: '待审核',
      statApproved: '已通过',
      statRejected: '已驳回',
      statUnreported: '未上报',
      // 搜索表单
      keyword: '关键字',
      keywordPlaceholder: '商户名/铺位名/合同号',
      reportMonth: '上报月份',
      reportMonthPlaceholder: '请选择月份',
      auditStatus: '审核状态',
      reportType: '填报类型',
      reportTypePlaceholder: '请选择填报类型',
      reportTypeMerchantSelf: '商户自报',
      reportTypeOperationProxy: '运营代报',
      reportTypeDiffAdjust: '差额调整',
      reportTypeSystemImport: '系统导入',
      dataSource: '数据来源',
      sourceManual: '手工录入',
      sourcePosSync: 'POS销售',
      sourceImport: '文件导入',
      // 表格列
      merchantName: '商户名称',
      shopName: '资产名称',
      contractNo: '合同编号',
      reportMonthCol: '上报月份',
      salesAmount: '销售金额（元）',
      reportedBy: '上报人',
      reportTime: '上报时间',
      reviewer: '审核人',
      reviewTime: '审核时间',
      rejectReason: '驳回原因',
      // 状态选项
      statusPending: '待审核',
      statusApproved: '已通过',
      statusRejected: '已驳回',
      // 操作按钮
      addReport: '新增上报',
      batchApprove: '批量通过',
      exportData: '导出',
      approve: '通过',
      reject: '驳回',
      withdraw: '撤回',
      // 对话框标题
      addTitle: '新增销售上报',
      editTitle: '编辑销售上报',
      detailTitle: '上报详情',
      rejectTitle: '审核驳回',
      // 表单字段
      merchant: '商户',
      merchantPlaceholder: '请选择商户',
      shop: '铺位',
      shopPlaceholder: '请选择铺位',
      brand: '品牌',
      contract: '关联合同',
      contractPlaceholder: '输入商户/品牌/铺位搜索合同',
      salesAmountLabel: '销售金额',
      salesAmountPlaceholder: '请输入销售金额',
      remarkLabel: '备注',
      remarkPlaceholder: '请输入备注',
      rejectReasonLabel: '驳回原因',
      rejectReasonPlaceholder: '请输入驳回原因',
      // 表单校验
      contractRequired: '请选择合同',
      reportMonthRequired: '请选择上报月份',
      salesAmountRequired: '请输入销售金额',
      rejectReasonRequired: '请输入驳回原因',
      // 确认消息
      approveConfirm: '确认审核通过该上报记录？',
      approveConfirmTitle: '审核确认',
      batchApproveConfirm: '确认批量通过所选 {count} 条记录？',
      batchApproveConfirmTitle: '批量审核',
      withdrawConfirm: '确认撤回该上报记录？',
      withdrawConfirmTitle: '确认撤回',
      deleteConfirm: '确认删除该上报记录？',
      deleteWarning: '警告',
      // 成功消息
      submitSuccess: '上报提交成功',
      updateSuccess: '修改成功',
      approveSuccess: '审核通过',
      rejectSuccess: '已驳回',
      batchApproveSuccess: '批量审核通过成功',
      withdrawSuccess: '已撤回',
      // 提示
      selectRecords: '请选择需要操作的记录',
      onlyPendingCanBatchApprove: '只能批量通过待审核的记录',
      // 周期类型
      periodType: '周期类型',
      periodTypeDaily: '按天',
      periodTypeMonthly: '按月',
      reportDate: '上报日期',
      attachments: '销售凭证',
      // V2: 业务类型
      tabAll: '全部',
      tabRental: '租赁',
      tabJoint: '联营',
      tabSelfOperated: '自营',
      businessType: '业务类型',
      businessTypeRental: '租赁',
      businessTypeJoint: '联营',
      businessTypeSelfOperated: '自营',
      transactionNo: '交易号',
      transactionTime: '交易时间',
      totalAmount: '实收金额',
      originalAmount: '原价总额',
      discountAmount: '折扣总额',
      totalQuantity: '总数量',
      // V2: 表单模式
      switchToDetail: '切换为详细录入',
      backToSimple: '返回简化模式',
      detailMode: '详细录入',
      simpleMode: '简化录入',
      // V2: 商品明细
      itemSection: '商品明细',
      addProductRow: '添加商品行',
      productName: '商品名称',
      skuCode: 'SKU编码',
      unitPrice: '单价',
      quantity: '数量',
      discountRate: '折扣率(%)',
      discountAmountCol: '折扣额',
      subtotal: '小计',
      itemProductRequired: '请选择商品',
      itemPriceRequired: '请输入单价',
      itemQuantityRequired: '请输入数量',
      // V2: 终端号
      terminalNo: '终端号',
      terminalNoPlaceholder: '请输入终端号',
      // V2: 销售小票
      receiptLabel: '销售小票',
      uploadReceipt: '上传小票',
      noReceipt: '暂无小票',
      // V2: 支付明细
      paymentSection: '支付方式',
      paymentMismatch: '支付合计与实收金额不一致',
      paymentTotal: '支付合计',
      // V2: 备注
      remarkLabel: '备注',
      remarkPlaceholder: '请输入备注信息',
      // 批量导入
      importSales: '批量导入',
      importStep1: '下载模板',
      importStep2: '上传文件',
      importStep3: '校验结果',
      importStep4: '完成',
      downloadTemplate: '下载导入模板',
      selectFile: '选择文件',
      validating: '正在校验...',
      importResult: '导入结果',
      validRows: '有效行数',
      invalidRows: '错误行数',
      confirmImport: '确认导入',
      importSuccess: '导入成功',
      importFailed: '导入失败',
      viewErrors: '查看错误',
    },
    // 现场管理
    site: {
      title: '现场管理',
      underDevelopment: '功能开发中...',
    },
    // 水电煤管理
    utility: {
      title: '水电煤管理',
      // 仪表台账
      meter: {
        title: '仪表台账',
        addMeter: '新增仪表',
        editMeter: '编辑仪表',
        detailMeter: '仪表详情',
        replaceMeter: '换表',
        bindContract: '绑定合同',
        meterCode: '仪表编号',
        meterCodePlaceholder: '请输入仪表编号',
        meterName: '仪表名称',
        meterNamePlaceholder: '请输入仪表名称',
        meterType: '仪表类型',
        meterTypePlaceholder: '请选择仪表类型',
        typeWater: '水表',
        typeElectric: '电表',
        typeGas: '燃气表',
        meterUsage: '用途',
        meterUsagePlaceholder: '请选择用途',
        usagePrivate: '商户专用',
        usagePublic: '公区',
        shop: '关联铺位',
        shopPlaceholder: '请选择铺位',
        contract: '关联合同',
        contractPlaceholder: '请选择合同',
        merchant: '商户',
        building: '楼栋',
        buildingPlaceholder: '请选择楼栋',
        floor: '楼层',
        floorPlaceholder: '请选择楼层',
        multiplier: '倍率',
        multiplierPlaceholder: '请输入倍率',
        initialReading: '初始读数',
        initialReadingPlaceholder: '请输入初始读数',
        unitPrice: '单价',
        unit: '单位',
        unitPlaceholder: '请输入计量单位',
        shareMethod: '分摊方式',
        shareMethodPlaceholder: '请选择分摊方式',
        shareByArea: '按面积',
        shareByUsage: '按用量',
        shareEqual: '均摊',
        shareScope: '分摊范围',
        shareScopePlaceholder: '分摊范围(楼栋/楼层)',
        status: '状态',
        statusActive: '使用中',
        statusInactive: '停用',
        statusScrapped: '已报废',
        installDate: '安装日期',
        installDatePlaceholder: '请选择安装日期',
        lastReading: '最近读数',
        lastReadingMonth: '最近抄表月',
        // 换表
        replaceTitle: '换表操作',
        finalReading: '旧表终止读数',
        finalReadingPlaceholder: '请输入旧表最终读数',
        newMeterCode: '新表编号',
        newMeterCodePlaceholder: '请输入新仪表编号',
        newInitialReading: '新表初始读数',
        newInitialReadingPlaceholder: '请输入新表初始读数',
        replaceSuccess: '换表成功',
        replaceConfirm: '确认换表？旧表将报废，自动创建新仪表',
        // 校验
        meterCodeRequired: '请输入仪表编号',
        meterNameRequired: '请输入仪表名称',
        meterTypeRequired: '请选择仪表类型',
        meterUsageRequired: '请选择用途',
        shopRequired: '专用仪表必须选择铺位',
        // 操作
        createSuccess: '仪表创建成功',
        updateSuccess: '仪表更新成功',
        deleteConfirm: '确认删除该仪表？',
        deleteSuccess: '仪表删除成功',
        bindSuccess: '合同绑定成功',
        keyword: '关键字',
        keywordPlaceholder: '仪表编号/名称/铺位/商户',
      },
      // 抄表管理
      reading: {
        title: '抄表管理',
        addReading: '录入抄表',
        batchSubmit: '批量录入',
        batchConfirm: '批量确认',
        batchGenerateFee: '批量生成费用',
        importReading: '导入抄表',
        exportData: '导出',
        // 统计卡片
        statPending: '待确认',
        statConfirmed: '已确认',
        statFeeGenerated: '已生费用',
        statAbnormal: '异常',
        statTotalUsage: '总用量',
        statTotalFee: '总费用(元)',
        // 搜索
        readingMonth: '抄表月份',
        readingMonthPlaceholder: '请选择月份',
        meterType: '仪表类型',
        meterUsage: '用途',
        status: '状态',
        keyword: '关键字',
        keywordPlaceholder: '仪表编号/铺位/商户',
        // 表格列
        meterCode: '仪表编号',
        meterName: '仪表名称',
        shopName: '铺位',
        merchantName: '商户',
        previousReading: '上次读数',
        currentReading: '本次读数',
        usageAmount: '用量',
        multiplier: '倍率',
        unitPrice: '单价',
        feeAmount: '费用(元)',
        readingSource: '数据来源',
        sourceManual: '手工录入',
        sourceImport: '批量导入',
        sourceAuto: '自动采集',
        isAbnormal: '异常',
        abnormalYes: '异常',
        abnormalNo: '正常',
        abnormalReason: '异常原因',
        readingTime: '抄表时间',
        reader: '抄表人',
        // 状态
        statusPending: '待确认',
        statusConfirmed: '已确认',
        statusFeeGenerated: '已生费用',
        // 操作
        confirm: '确认',
        generateFee: '生成费用',
        calculateShare: '计算公摊',
        fillAbnormalReason: '填写异常原因',
        // 对话框
        submitTitle: '录入抄表数据',
        importTitle: '导入抄表数据',
        abnormalReasonTitle: '填写异常原因',
        meter: '仪表',
        meterPlaceholder: '请选择仪表',
        currentReadingLabel: '本次读数',
        currentReadingPlaceholder: '请输入本次读数',
        readingTimePlaceholder: '请选择抄表时间',
        readerPlaceholder: '请输入抄表人',
        // 校验
        meterRequired: '请选择仪表',
        currentReadingRequired: '请输入本次读数',
        readingMonthRequired: '请选择抄表月份',
        // 成功消息
        submitSuccess: '抄表数据提交成功',
        confirmSuccess: '抄表已确认',
        batchConfirmSuccess: '批量确认成功',
        generateFeeSuccess: '费用生成成功',
        batchGenerateFeeSuccess: '批量生成费用成功',
        calculateShareSuccess: '公摊计算完成，共分摊{count}户',
        importSuccess: '导入成功{success}条，失败{fail}条',
        abnormalReasonSuccess: '异常原因已更新',
        // 提示
        selectRecords: '请选择需要操作的记录',
        onlyPendingCanConfirm: '只有待确认的记录可以确认',
        onlyConfirmedCanGenerate: '只有已确认的记录可以生成费用',
        onlyPublicCanShare: '只有公区仪表的抄表记录可以计算公摊',
        // 确认
        confirmConfirmMsg: '确认该抄表记录？确认后不可修改',
        confirmTitle: '确认抄表',
        generateFeeConfirmMsg: '确认生成费用？将写入月度费用表',
        generateFeeTitle: '生成费用',
        calculateShareConfirmMsg: '确认计算公摊？将按分摊规则生成各商户费用',
        calculateShareTitle: '计算公摊',
      },
      // 单价配置
      price: {
        title: '单价配置',
        addPrice: '新增单价',
        editPrice: '编辑单价',
        priceName: '价格名称',
        priceNamePlaceholder: '请输入价格名称',
        meterType: '仪表类型',
        unitPrice: '单价',
        unitPricePlaceholder: '请输入单价',
        unit: '计量单位',
        unitPlaceholder: '请输入计量单位',
        effectiveDate: '生效日期',
        effectiveDatePlaceholder: '请选择生效日期',
        expireDate: '失效日期',
        expireDatePlaceholder: '请选择失效日期(可选)',
        isDefault: '默认价格',
        isDefaultYes: '是',
        isDefaultNo: '否',
        // 校验
        priceNameRequired: '请输入价格名称',
        meterTypeRequired: '请选择仪表类型',
        unitPriceRequired: '请输入单价',
        effectiveDateRequired: '请选择生效日期',
        // 操作
        saveSuccess: '单价配置保存成功',
        deleteConfirm: '确认删除该单价配置？',
        deleteSuccess: '单价配置删除成功',
      },
    },
  },
  // 报表中心
  report: {
    leaseRate: {
      title: '出租率分析',
      // 总览卡片
      totalLeasableArea: '总可租面积',
      leasedArea: '已租面积',
      vacantArea: '空置面积',
      overallLeaseRate: '整体出租率',
      // 图表标题
      floorLeaseRateChart: '各楼层出租率',
      businessTypeLeaseRateChart: '各业态出租率',
      targetLine: '目标线',
      // 明细表格
      detailTable: '出租率明细',
      totalShops: '铺位总数',
      leasedShops: '已租铺位',
      colTotalArea: '总面积（㎡）',
      colLeasedArea: '已租面积（㎡）',
      colVacantArea: '空置面积（㎡）',
      colLeaseRate: '出租率',
      footerTotal: '合计',
    },
  },
}
